// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ekc2Q","text":"styles_text__fG-sc","button":"styles_button__ct3Nu"};